var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bpc-access-control-badge-list',{attrs:{"with-url-params":true,"show-create-button":false}})}
var staticRenderFns = []

export { render, staticRenderFns }